import React from 'react'
import { SupabaseAuthProvider } from '@/lib/hooks/auth'
import { ManagementSyncProvider } from '@/lib/realtime/managementSync'
import { Toaster } from '@/components/ui/sonner'
import { AppErrorBoundary } from './AppErrorBoundary'
import { AppRouter } from './router/AppRouter'

function App(): React.JSX.Element {
  return (
    <AppErrorBoundary>
      <SupabaseAuthProvider>
        <ManagementSyncProvider>
          <Toaster />
          <AppRouter />
        </ManagementSyncProvider>
      </SupabaseAuthProvider>
    </AppErrorBoundary>
  )
}

export default App
